import fetcher from "../helpers/fetcher";

export async function GetAllCampaigns(page, searchTerm = "", dateFilter = "") {
  let path = `/campaigns?page=${page}&search=${searchTerm}&dateFilter=${dateFilter}`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function CreateCampaign(body) {
  let path = `/campaigns`;
  let request = await fetcher(path, "POST", body);
  let content = await request.json();
  return content;
}

export async function CreateCampaignDraft(body) {
  let path = `/campaigns`;
  // Parse the JSON string, add is_draft, then stringify again
  const bodyObj = JSON.parse(body);
  const draftBody = { ...bodyObj, is_draft: true };
  let request = await fetcher(path, "POST", JSON.stringify(draftBody));
  let content = await request.json();
  return content;
}

export async function DeleteCampaign(id, deleteVideos) {
  let path = `/campaigns/${id}?deleteVideos=${deleteVideos}`;
  let request = await fetcher(path, "DELETE");
  let content = await request.json();
  return content;
}

export async function GetCampaignInfo(id) {
  let path = `/campaigns/${id}/details`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function UpdateCampaignDetails(id, body) {
  let path = `/campaigns/${id}`;
  let request = await fetcher(path, "PUT", body);
  let content = await request.json();
  return content;
}

export async function GetCampaignAnalytics(id, from, to, page) {
  let path = `/campaigns/${id}/analytics?from=${from}&to=${to}&page=${page}`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function ExportCampaignReportsToExcel(id, from, to) {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append("from", from);
  if (to) queryParams.append("to", to);
  queryParams.append("export", "excel");

  const token = localStorage.getItem("token");

  const url = `${
    process.env.REACT_APP_REQUEST_URL
  }/campaigns/${id}/analytics?${queryParams.toString()}`;
  console.log("Downloading from:", url);

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to download Excel file");
  }

  const blob = await response.blob();
  const filename = response.headers.get("File-Name") || "campaign_report.xlsx";

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function ExportCampaignToExcel(campaignId) {
  const token = localStorage.getItem("token");

  const url = `${process.env.REACT_APP_REQUEST_URL}/campaigns/${campaignId}/export`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to download Excel file");
  }

  const blob = await response.blob();
  const filename = response.headers.get("File-Name") || `campaign_${campaignId}_export.xlsx`;

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function GenerateCampaignPlaylist(id) {
  let path = `/campaigns/${id}/generate-playlist`;
  let request = await fetcher(path, "POST");
  let content = await request.json();
  return content;
}
